import { Layout } from "antd";
import { Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/authContext";
import "../assets/css/layout.css";
import { useSidebar } from "../context/sidebarContext";
// import Sidebar from "../components/layout/Sidebar";
// import FooterBar from "../components/layout/FooterBar";
// import Navbar from "../components/layout/Navbar";
// import NavBar2 from "../components/layout/NavBar2";

const { Content } = Layout;

const MainLayout = () => {
  const { currentUser } = useContext(AuthContext);
  const { collapsed } = useSidebar();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }


  return (
    <>
      <Layout className="outer-layout" hasSider>
        {/* <Sidebar /> style={{ marginLeft: collapsed ? 90 : 260 }}*/}
        <Layout className="inner-layout" >
          {/* <Navbar />   */}
          {/* <NavBar2/> */}
          <Content>
            
            <Outlet />
          </Content>
          {/* <FooterBar /> */}
        </Layout>
      </Layout>
    </>
  );
};

export default MainLayout;
